<template>
      <span v-if="initialsToShow" class="initials" :style="style">{{ initialsToShow }}</span>
</template>

<script>
    export default {
        name: "Initials",
        props: {
            initials: { type: String },
            firstName: { type: String },
            lastName: { type: String },
            width: { type: String, default: "2.5rem" },
            fontSize: { type: String, default: "1rem" }
        },

        computed: {
            initialsToShow() {
               if(this.initials) {
                   return this.initials.toUpperCase();
               } else if( !!this.firstName && !!this.lastName) {
                   return this.firstName[0].toUpperCase() + this.lastName[0].toUpperCase()
               } else {
                   return "";
               }
            },

            style() {
                return `font-size:${this.fontSize}; width:${this.width}; height:${this.width};`
            }
        }
    }
</script>